import React from 'react'

const getClassName = type => {
    if('facebook' === type) {
        return ' link-social-fb'
    } else if('twitter' === type) {
        return ' link-social-twitter'
    } else if('tiktok' === type) {
        return ' link-social-tiktok'
    } else if('whatsapp' === type) {
        return ' link-social-whatsapp'
    } else {
        return ' link-social-insta'
    }
}

const SocialMediaLink = ({type, url}) => (
    <div className={"link-social" +  getClassName(type)}>
        <a href={url} rel="noreferrer" target="_blank">
            <span className="screen-reader-text">{type}</span>
        </a>
    </div>
)

export default SocialMediaLink